import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-search-remove",
  "use": "app-icon-search-remove-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"app-icon-search-remove\"><path d=\"M7 0c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7zm0 1.313A5.699 5.699 0 001.312 7 5.699 5.699 0 007 12.688 5.699 5.699 0 0012.688 7 5.699 5.699 0 007 1.312zm2.844 5.03c.326 0 .601.247.649.56L10.5 7a.661.661 0 01-.656.656H4.156a.662.662 0 01-.649-.56L3.5 7c0-.359.297-.656.656-.656h5.688z\" fill=\"#707070\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol